// extracted by mini-css-extract-plugin
export default {"featuredPages":"Jmzvg","list":"FvOfQ","item":"J6g0E","thumbnailImg":"znjAb","defaultImg":"sYw7m","thumbnail":"vdJGV","itemTitle":"xUlKJ"};